import React from 'react';
import axios from 'axios';
import { ReqEditDeviceMonitoring } from '../types/api/Devices';
import { ApiUrl } from '../conf/config';

export const useEditDeviceMonitoring = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const editDeviceMonitoring = (id: string, device: ReqEditDeviceMonitoring) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .put(`${ApiUrl}/admin/api/v1/devices/${id}/monitoring`, device, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { editDeviceMonitoring, loading, error };
};
